import React from 'react';

const Bar = ({ value, max, color }) => (
  <div className="h-1.5 bg-[rgba(0,0,0,0.3)] rounded-full overflow-hidden flex-1">
    <div
      className="h-full rounded-full transition-all duration-700"
      style={{ width: `${Math.min(100, (value / (max || 1)) * 100)}%`, backgroundColor: color }}
    />
  </div>
);

const StatRow = ({ label, awayVal, homeVal }) => {
  const max = Math.max(Number(awayVal) || 0, Number(homeVal) || 0, 1);
  return (
    <div className="flex items-center gap-2 py-1.5 border-b border-[rgba(101,141,113,0.2)] last:border-0">
      <div className="flex items-center gap-1.5 flex-1 justify-end">
        <span className="text-white text-xs font-bold tabular-nums">{awayVal ?? '--'}</span>
        <Bar value={Number(awayVal) || 0} max={max} color="#a9c9b1" />
      </div>
      <span className="text-[9px] uppercase tracking-widest text-[#658d71] font-bold w-16 text-center shrink-0">{label}</span>
      <div className="flex items-center gap-1.5 flex-1">
        <Bar value={Number(homeVal) || 0} max={max} color="#c4333e" />
        <span className="text-white text-xs font-bold tabular-nums">{homeVal ?? '--'}</span>
      </div>
    </div>
  );
};

const TeamStatComparison = ({ boxScore, awayAbbr, homeAbbr }) => {
  if (!boxScore) return null;
  const away = boxScore.teams?.away?.teamStats?.batting;
  const home = boxScore.teams?.home?.teamStats?.batting;
  const awayP = boxScore.teams?.away?.teamStats?.pitching;
  const homeP = boxScore.teams?.home?.teamStats?.pitching;

  return (
    <div>
      <div className="flex justify-between text-[10px] font-black uppercase tracking-widest mb-3">
        <span className="text-[#a9c9b1]">{awayAbbr}</span>
        <span className="text-[#658d71]">Stat</span>
        <span className="text-[#c4333e]">{homeAbbr}</span>
      </div>
      <StatRow label="Hits" awayVal={away?.hits} homeVal={home?.hits} />
      <StatRow label="Runs" awayVal={away?.runs} homeVal={home?.runs} />
      <StatRow label="HR" awayVal={away?.homeRuns} homeVal={home?.homeRuns} />
      <StatRow label="K's" awayVal={awayP?.strikeOuts} homeVal={homeP?.strikeOuts} />
      <StatRow label="BB" awayVal={away?.baseOnBalls} homeVal={home?.baseOnBalls} />
      <StatRow label="LOB" awayVal={away?.leftOnBase} homeVal={home?.leftOnBase} />
      <StatRow label="Avg" awayVal={away?.avg} homeVal={home?.avg} />
    </div>
  );
};

export default TeamStatComparison;